// extracted by mini-css-extract-plugin
export default {"loginExternalServiceDeniedWrapper":"styles_loginExternalServiceDeniedWrapper__QWry0","buttons":"styles_buttons__feico"};